var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 6.66667L22.9835 9.01667L27.2835 13.3333H10.3335V16.6667H27.2835L22.9835 20.9667L25.3335 23.3333L33.6668 15M3.66683 3.33333H17.0002V0H3.66683C1.8335 0 0.333496 1.5 0.333496 3.33333V26.6667C0.333496 28.5 1.8335 30 3.66683 30H17.0002V26.6667H3.66683V3.33333Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.bb16bd4dcc27104105df11507b61d73f.svg";
export { ForwardRef as ReactComponent };